import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, FieldArray } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import ShowAlert from "../alert";
import { IoIosSave, IoIosReturnLeft } from "react-icons/io";
import MasterService from "../../Services/MasterService";
import SwaranandhraService from "../../Services/SwaranandhraService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { IoReturnDownForward } from "react-icons/io5";
// import ReactTooltip from "react-tooltip";
import { PiNotePencilDuotone } from "react-icons/pi";
import { Container, Row, Col, Nav, Tab, Button, Modal } from "react-bootstrap";
import { RiUserFollowLine } from "react-icons/ri";
import { FaArrowRightLong } from "react-icons/fa6";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { FaRegFile, FaUserCheck, FaBookmark, FaRegSave } from "react-icons/fa";
import "jspdf-autotable";
import jsPDF from "jspdf";
// import * as XLSX from "sheetjs-style";
import * as XLSX from 'xlsx';

import { Link } from "@mui/material";

export default function DataEntryForTargets() {
  const [distEnb, setDistEnb] = useState(false); const [manEnb, setManEnb] = useState(false); const [addModal, setAddModal] = useState(); const [searchText, setSearchText] = useState(""); const [enb, setEnb] = useState(false); const [distlist, setDistlist] = useState(); const [mandallist, setMandallist] = useState(); const [buttontype, setButtontype] = useState(""); const [submandal, setSubmandal] = useState([]); const [workFlow, setWorkFlow] = useState([]); const [forwardto, setForwardto] = useState(); const [roleId, setRoleId] = useState(); const [forwardList, setForwardList] = useState([]); const [mandalid, setMandalid] = useState(""); const [enbSub, setEnbSub] = useState(false); const [currentstatus, setCurrentstatus] = useState(""); const [mandalName, setMandalName] = useState(""); const [sourcelist, setSourcelist] = useState([]); const [adforward, setAdforward] = useState([]); const [isbuttonChecked, setIsbuttonChecked] = useState(false); const [activeTab, setActiveTab] = useState("target"); const [buttontypegdmp, setButtontypegdmp] = useState(""); const [addModal1, setAddModal1] = useState();

  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid");

  const formik = useFormik({
    initialValues: {
      userId: "",
      district_id: "",
      mandal_id: "",
      f_year: "",
      swaIndicatorsTargetDto: [],
      gmdpContributionSubListDto: [],
      forward: "",
      forward_to: "",
      role_id: "",
    },
    onSubmit: (values) => {
      setEnb(false);
      if (values.district_id !== "") {
        let params = { userId: username, district_id: values.district_id };
        store.dispatch({ type: "SHOW_SPINNER" });
        SwaranandhraService.saveEntryForTarget(params)
          .then((res) => {
            if (res.data && res.data.SCODE === "01") {
              setSubmandal(res.data.SDESC);
              setEnbSub(true);
              setEnb(false);
            }
          })
          .finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
          });
      }
    },
  });

  React.useEffect(() => {
    if (roleid === "2" || roleid === "10") {
      setDistEnb(true); setManEnb(false);
    }
    if (roleid === "3") {
      setDistEnb(true); setManEnb(true);
    }
    if (roleid === "5") {
      setDistEnb(false); setManEnb(false);
    }
    district !== "0" ? formik.setFieldValue("district_id", district) : formik.setFieldValue("district_id", "");
    let params = { district_id: district };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); });
        setMandallist(options);
      }
    });
    formik.setFieldValue("mandal_id", mandal !== "0" && mandal !== "00" ? mandal : "");
  }, []);

  useEffect(() => {
    MasterService.getSourceoffunding().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); });
        setSourcelist(options);
      }
    });

    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        let options = res17.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); });
        setDistlist(options);
      }
    });

    if (roleid === "3") {
      let params = { userId: username, district_id: district, mandal_id: mandal };
      store.dispatch({ type: "SHOW_SPINNER" });
      MasterService.getSubIndicatorsForTarget(params)
        .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            const mappedData = res.data.SDESC.map((indicator) => {
              return {
                indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
              };
            });
            formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res.data.buttontype); setWorkFlow(res.data.workFlow); setRoleId(res.data.SDESC[1].role_id); setForwardto(res.data.SDESC[1].forward_to); setCurrentstatus(res.data.current_status);
          }
          setEnb(true); setActiveTab("target"); setEnbSub(false);
        })
        .catch((err) => {
          ShowAlert(err, "error");
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });

      let params1 = { district_id: district };

      SwaranandhraService.getAsoForward(params1)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            const item = res.data[0];
            formik.setFieldValue("forward", `${item.id},${item.roleid}`, false); formik.setFieldValue("forward_to", item.id, false); formik.setFieldValue("role_id", item.roleid, false);
            const options = ( <option key={item.id} value={`${item.id},${item.roleid}`}> {item.value} </option> );
            setForwardList([options]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else if (roleid === "2" || roleid === "10") {
      setEnbSub(true); setActiveTab("target"); setEnb(false);
      let params18 = { userId: username, district_id: district, };
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.saveEntryForTarget(params18)
        .then((res18) => {
          if (res18.data && res18.data.SCODE === "01") {
            setSubmandal(res18.data.SDESC); setEnbSub(true); setEnb(false);
          }
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }
  }, []);

  const hasAtLeastOneReject = (data) => {
    return data.some((indicator) => indicator.is_reject);
  };

  const hasRejectIndicators = (data) => {
    return data.some((indicator) => indicator.is_reject === true);
  };

  const SaveData = () => {
    const hasInvalidValues2 = (data) => {
      return data.some((indicator) => {
        if (indicator.sub_indicator_id == null || indicator.sub_indicator_id === "") {
          return false;
        }
        const years = ["2024_2025", "2025_2026", "2026_2027", "2027_2028", "2028_2029"];
        return indicator.achived == null || indicator.achived === "" || years.some((year) => indicator[`target_${year}`] === null || indicator[`target_${year}`] === "");
      });
    };

    if (hasInvalidValues2(formik.values.swaIndicatorsTargetDto)) {
      ShowAlert("Please fill all fields", "error");
      return;
    }

    const transformFormikData = () => {
      return formik.values.swaIndicatorsTargetDto.map((indicator) => {
        const yearWiseTargets = [];
        const years = ["2024_2025", "2025_2026", "2026_2027", "2027_2028", "2028_2029"];
        years.forEach((year, index) => {
          const targetValue = indicator[`target_${year}`];
          yearWiseTargets.push({
            target: targetValue !== null && targetValue !== undefined && targetValue !== "" ? parseFloat(targetValue) : 0,
            f_year: 2024 + index,
          });
        });
        return {
          indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id,
          achived: indicator.achived !== null && indicator.achived !== undefined && indicator.achived !== "" ? parseFloat(indicator.achived) : 0,
          expected_source_of_funding: indicator.expected_source_of_funding, swaIndicatorsTargetYearWiseDto: yearWiseTargets, is_reject: indicator.is_reject,
        };
      });
    };

    const transformedData = transformFormikData();

    let params = {
      userId: username,
      type: buttontype,
      district_id: district,
      mandal_id: roleid === "3" ? mandal : mandalid,
      forward_to: forwardto, role_id: roleId, swaIndicatorsTargetDto: transformedData,
    };

    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.saveEntryForTarget(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") {
          ShowAlert(res.data.SDESC, "success");
          if (roleid === "3") {
            let params2 = { userId: username, district_id: formik.values.district_id, mandal_id: formik.values.mandal_id, };
            MasterService.getSubIndicatorsForTarget(params2).then((res2) => {
              if (res2.data && res2.data.SCODE === "01") {
                const mappedData = res2.data.SDESC.map((indicator) => {
                  return {
                    indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                  };
                });
                formik.setFieldValue("swaIndicatorsTargetDto", mappedData);
                setButtontype(res2.data.buttontype); setWorkFlow(res2.data.workFlow); setRoleId(res2.data.SDESC[1].role_id); setForwardto(res2.data.SDESC[1].forward_to); setCurrentstatus(res2.data.current_status);
              }
            });
          }
        }
      })
      .catch((err) => {
        ShowAlert(err, "error");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const SubmitData = () => {
    if (!formik.values.remarks) {
      ShowAlert("Enter Remarks", "warning");
      return;
    }

    if (roleid === "3") {
      const transformFormikData = () => {
        return formik.values.gmdpContributionSubListDto.map((sector) => {
          return {
            sector_id: sector.sector_id,
            industry_id: sector.industry_id,
            gmdp: sector.gmdp !== null && sector.gmdp !== undefined && sector.gmdp !== "" ? parseFloat(sector.gmdp) : 0,
            contribution: sector.contribution !== null && sector.contribution !== undefined && sector.contribution !== "" ? parseFloat(sector.contribution) : 0,
            is_reject: sector.is_reject,
          };
        });
      };
      const transformedData = transformFormikData();
      let params1 = {
        userId: username,
        button_type: buttontypegdmp,
        district_id: district,
        mandal_id: roleid === "3" ? mandal : mandalid,
        forward_to: forwardto, role_id: roleId, gmdpContributionSubListDto: transformedData,
      };
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.gmdpContributions(params1)
        .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            let params3 = {
              userId: username,
              district_id: roleid === "5" ? formik.values.district_id : district,
              mandal_id: roleid === "3" ? mandal : mandalid,
              forward_to: formik.values.forward_to,
              remarks: formik.values.remarks,
              role_id: parseInt(formik.values.role_id),
            };
            SwaranandhraService.gettargetsAndGmdpForward(params3).then((res3) => {
              if (res3.data && res3.data.SCODE === "01") {
                ShowAlert(res3.data.SDESC, "success"); setAddModal(false);
                if (roleid === "3") {
                  let params4 = { userId: username, district_id: formik.values.district_id, mandal_id: formik.values.mandal_id, };

                  MasterService.getSubIndicatorsForTarget(params4).then((res4) => {
                    if (res4.data && res4.data.SCODE === "01") {
                      const mappedData = res4.data.SDESC.map((indicator) => {
                        return {
                          indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029,
                          target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                        };
                      });
                      formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res4.data.buttontype); setWorkFlow(res4.data.workFlow); setRoleId(res4.data.SDESC[1].role_id); setForwardto(res4.data.SDESC[1].forward_to); setCurrentstatus(res4.data.current_status);
                    }
                  });

                  SwaranandhraService.gmdpContributions(params4).then((res5) => {
                    if (res5.data && res5.data.SCODE === "01") {
                      const mappedData = res.data.SDESC.map((indicator) => {
                        return {
                          sector_id: indicator.sector_id, industry_id: indicator.industry_id, sector_name: indicator.sector_name, industry_name: indicator.industry_name, is_data_entry: indicator.is_data_entry, contribution: indicator.contribution, gmdp: indicator.gmdp, is_reject: indicator.is_reject,
                        };
                      });

                      formik.setFieldValue("gmdpContributionSubListDto", mappedData); setButtontypegdmp(res5.data.buttonType); setWorkFlow(res5.data.workFlow); setRoleId(res5.data.SDESC[1].role_id); setForwardto(res5.data.SDESC[1].forward_to); setCurrentstatus(res5.data.current_status);
                    }
                    setEnb(true);
                  });
                } else if (roleid === "2" || roleid === "10" || roleid === "5" || roleid === "8") {
                  let params6 = {
                    userId: username,
                    district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
                  };
                  SwaranandhraService.saveEntryForTarget(params6).then((res6) => {
                    if (res6.data && res6.data.SCODE === "01") {
                      setSubmandal(res6.data.SDESC); setEnbSub(true); setEnb(false);
                    }
                  });
                }
              }
            });
          }
        })
        .catch((err) => {
          ShowAlert(err, "error");
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    } else if (roleid !== "3") {
      let params = {
        userId: username,
        district_id: roleid === "5" ? formik.values.district_id : district,
        mandal_id: roleid === "3" ? mandal : mandalid,
        forward_to: formik.values.forward_to,
        remarks: formik.values.remarks,
        role_id: parseInt(formik.values.role_id),
      };
      SwaranandhraService.gettargetsAndGmdpForward(params).then((res) => {
        if (res.data && res.data.SCODE === "01") {
          ShowAlert(res.data.SDESC, "success");
          setAddModal(false);
          if (roleid === "3") {
            let params7 = { userId: username, district_id: formik.values.district_id, mandal_id: formik.values.mandal_id, };
            MasterService.getSubIndicatorsForTarget(params7).then((res7) => {
              if (res7.data && res7.data.SCODE === "01") {
                const mappedData = res7.data.SDESC.map((indicator) => {
                  return {
                    indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029,
                    unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                  };
                });
                formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res7.data.buttontype); setWorkFlow(res7.data.workFlow); setRoleId(res7.data.SDESC[1].role_id); setForwardto(res7.data.SDESC[1].forward_to); setCurrentstatus(res7.data.current_status);
              }
            });

            SwaranandhraService.gmdpContributions(params7).then((res8) => {
              if (res8.data && res8.data.SCODE === "01") {
                const mappedData = res8.data.SDESC.map((indicator) => {
                  return {
                    sector_id: indicator.sector_id, industry_id: indicator.industry_id, sector_name: indicator.sector_name, industry_name: indicator.industry_name, is_data_entry: indicator.is_data_entry, contribution: indicator.contribution, gmdp: indicator.gmdp, is_reject: indicator.is_reject,
                  };
                });

                formik.setFieldValue("gmdpContributionSubListDto", mappedData); setButtontypegdmp(res8.data.buttonType); setWorkFlow(res8.data.workFlow); setRoleId(res8.data.SDESC[1].role_id); setForwardto(res8.data.SDESC[1].forward_to); setCurrentstatus(res8.data.current_status);
              }
              setEnb(true);
            });
          } else if (roleid === "2" || roleid === "10" || roleid === "5" || roleid === "8") {
            let params1 = {
              userId: username,
              district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
            };
            SwaranandhraService.saveEntryForTarget(params1).then((res1) => {
              if (res1.data && res1.data.SCODE === "01") {
                setSubmandal(res1.data.SDESC);
                setEnbSub(true);
                setEnb(false);
              }
            });
          }
        }
      });
    }
  };

  function generatePdf() {
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [900, 800] });
    doc.autoTable({
      html: "#my-table", 
      theme: "grid",
      tableWidth: 530,
      columnStyles: { 3: { cellWidth: "wrap" } },
      styles: { fontSize: 8 },
      columns: [
        { header: "Sl.No.", dataKey: "Sl.No." },
        { header: "INDICATOR", dataKey: "INDICATOR" },
        { header: "UNIT", dataKey: "UNIT" },
        { header: "ACHIEVEMENTS", dataKey: "ACHIEVEMENTS" },
        { header: "TARGET 2024-25", dataKey: "TARGET 2024-25" },
        { header: "TARGET 2025-26", dataKey: "TARGET 2025-26" },
        { header: "TARGET 2026-27", dataKey: "TARGET 2026-27" },
        { header: "TARGET 2027-28", dataKey: "TARGET 2027-28" },
        { header: "TARGET 2028-29", dataKey: "TARGET 2028-29" },
        { header: "Indicative Financial Plan", dataKey: "Indicative Financial Plan" },
      ],
      didParseCell: function (data) {
      },
    });
    doc.save("Targets & Achievements Report.pdf");
  }

  function generatePdf1() {
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [900, 800] });

    doc.autoTable({
      html: "#my-table1",
      theme: "grid",
      tableWidth: 530,
      columnStyles: { 3: { cellWidth: "wrap" } },
      styles: { fontSize: 8 },
      columns: [
        { header: "Sl.No.", dataKey: "Sl.No." },
        { header: "BROAD SECTOR", dataKey: "BROAD SECTOR" },
        { header: "SUB SECTOR", dataKey: "SUB SECTOR" },
        { header: "GVA (Rs. in Lakhs)", dataKey: "GVA (Rs. in Lakhs)" },
        { header: "Contribution (%)", dataKey: "Contribution (%)" },
      ],
      didParseCell: function (data) {
        if (data.column.index === 5) {
          data.cell.styles.textColor = "white"; 
        }
      },
    });

    doc.save("Gross Mandal Domestic Report.pdf");
  }

  const exportToExcel = (tableId, fileName) => {
    const table = document.getElementById(tableId);
    if (!table) {
      console.error(`Table with ID ${tableId} not found!`);
      return;
    }

    try {
      const sheetName = fileName.length > 31 ? fileName.substring(0, 31) : fileName;

      const ws = XLSX.utils.table_to_sheet(table);

      const range = XLSX.utils.decode_range(ws["!ref"]);
      if (roleid !== "3") {
        range.e.c = range.e.c - 1;
      }

      ws["!ref"] = XLSX.utils.encode_range(range);

      const columnWidths = [];
      for (let col = 0; col <= range.e.c; col++) {
        const colLetter = XLSX.utils.encode_col(col);
        const cellWidth = Math.max(
          ...Object.keys(ws)
            .filter((cell) => cell.startsWith(colLetter))
            .map((cell) => (ws[cell] ? (ws[cell].v ? ws[cell].v.toString().length : 0) : 0))
        );
        columnWidths[col] = { wch: cellWidth + 2 };
      }
      ws["!cols"] = columnWidths;

      const headerRow = range.s.r;
      for (let col = 0; col <= range.e.c; col++) {
        const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c: col })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center" },
            font: { bold: true },
          };
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  const Return = () => {
    if (!formik.values.remarks) {
      ShowAlert("Enter Remarks", "warning");
      return;
    }

    const transformFormikData = () => {
      return formik.values.swaIndicatorsTargetDto.map((indicator) => {
        const yearWiseTargets = [];
        const years = ["2024_2025", "2025_2026", "2026_2027", "2027_2028", "2028_2029"];
        years.forEach((year, index) => {
          if (indicator[`target_${year}`] !== undefined && indicator[`target_${year}`] !== "") {
            yearWiseTargets.push({
              target: parseFloat(indicator[`target_${year}`]),
              f_year: 2024 + index,
            });
          }
        });
        return {
          indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: parseFloat(indicator.achived), swaIndicatorsTargetYearWiseDto: yearWiseTargets, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding,
        };
      });
    };
    const transformFormikData1 = () => {
      return formik.values.gmdpContributionSubListDto.map((sector) => {
        return {
          sector_id: sector.sector_id,
          industry_id: sector.industry_id,
          gmdp: parseFloat(sector.gmdp),
          contribution: parseFloat(sector.contribution) || 0,
          is_reject: sector.is_reject,
        };
      });
    };
    const transformedData = transformFormikData();
    const transformedData1 = transformFormikData1();
    let params = {
      userId: username,
      district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
      mandal_id: roleid === "3" ? mandal : mandalid,
      targetsAndAchievementsDto: transformedData,
      gmdpContributionsDto: transformedData1,
      forward_to: formik.values.forward_to,
      remarks: formik.values.remarks,
      role_id: parseInt(formik.values.role_id),
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.gettargetsAndGmdpReturn(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") {
          ShowAlert(res.data.SDESC, "success");
          setAddModal1(false);

          if (roleid === "3") {
            let params9 = {
              userId: username,

              district_id: district,
              mandal_id: mandal,
            };
            store.dispatch({ type: "SHOW_SPINNER" });
            MasterService.getSubIndicatorsForTarget(params9)
              .then((res9) => {
                if (res9.data && res9.data.SCODE === "01") {
                  const mappedData = res9.data.SDESC.map((indicator) => {
                    return {
                      indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                    };
                  });
                  formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res9.data.buttontype); setWorkFlow(res9.data.workFlow); setRoleId(res9.data.SDESC[1].role_id); setForwardto(res9.data.SDESC[1].forward_to); setCurrentstatus(res9.data.current_status);
                }

                setEnb(true);
              })
              .catch((err) => {
                ShowAlert(err, "error");
              })
              .finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
              });

            let params1 = {
              district_id: district,
            };

            SwaranandhraService.getAsoForward(params1)
              .then((res10) => {
                if (res10.data && res10.data.length > 0) {
                  const item = res10.data[0]; formik.setFieldValue("forward", `${item.id},${item.roleid}`, false); formik.setFieldValue("forward_to", item.id, false); formik.setFieldValue("role_id", item.roleid, false);
                  const options = ( <option key={item.id} value={`${item.id},${item.roleid}`}> {item.value} </option> );
                  setForwardList([options]);
                }
              })
              .catch((error) => {
                console.error("Error fetching data:", error);
              });
          }

          if (roleid !== "3") {
            if (roleid === "2" || roleid === "5" || roleid === "8") {
              let params11 = {
                district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
                mandal_id: mandalid,
              };
              SwaranandhraService.getCpoForward(params11).then((res11) => {
                if (res11.data) {
                  const item = res11.data[0];
                  formik.setFieldValue("forward", `${item.id},${item.roleid}`, false); formik.setFieldValue("forward_to", item.id, false); formik.setFieldValue("role_id", item.roleid, false);
                  let options = res11.data.map((detail, i) => {
                    return (
                      <option key={i} value={`${detail.id},${detail.roleid}`}>
                        {detail.value}
                      </option>
                    );
                  });
                  setForwardList(options);
                }
              });
            } else if (roleid === "10") {
              let params12 = {
                district_id: district,
                mandal_id: mandalid,
              };
              SwaranandhraService.getAdForward(params12).then((res12) => {
                if (res12.data) {
                  setAdforward(res12.data);
                  let options = res12.data.map((item, i) => { return ( <option key={i} value={`${item.id},${item.roleid}`}> {item.value} </option> ); });
                  setForwardList(options);
                }
              });
            }

            let params13 = { userId: username, district_id: formik.values.district_id, mandal_id: mandalid, };
            store.dispatch({ type: "SHOW_SPINNER" });
            MasterService.getSubIndicatorsForTarget(params13)
              .then((res13) => {
                if (res13.data && res13.data.SCODE === "01") {
                  const mappedData = res13.data.SDESC.map((indicator) => {
                    return {
                      indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029,
                      unit: indicator.unit, is_reject: indicator.is_reject, expected_source_of_funding: indicator.expected_source_of_funding, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                    };
                  });
                  formik.setFieldValue("swaIndicatorsTargetDto", mappedData);
                  setButtontype(res13.data.buttonType); setWorkFlow(res13.data.workFlow); setRoleId(res13.data.SDESC[1].role_id); setForwardto(res13.data.SDESC[1].forward_to); setMandalName(res13.data.SDESC[1].mandal_name); setEnb(true); setEnbSub(false); setCurrentstatus(res13.data.current_status);
                }
              })
              .catch((err) => {
                ShowAlert(err, "error");
              })
              .finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
              });
          }
        }
      })
      .catch((err) => {
        ShowAlert(err, "error");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const allowNumbersOnly = (e, maxLength) => {
    const input = e.target;
    const value = input.value;
    const key = e.key;
    const fieldMaxlength = maxLength === null || maxLength === undefined ? 9 : maxLength;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    if (allowedKeys.includes(key)) {
      return;
    }
    const regex = new RegExp(`^\\d{0,${fieldMaxlength}}(\\.\\d{0,2})?$`);
    const { selectionStart, selectionEnd } = input;
    const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);
    if (!regex.test(newValue)) {
      e.preventDefault();
    }
  };

  const allowNumbersOnly1 = (e) => {
    const input = e.target;
    const value = input.value;
    const key = e.key;

    const regex = /^\d{0,3}(\.\d{0,2})?$/;

    if (key === "Backspace" || key === "Delete" || key === "ArrowLeft" || key === "ArrowRight") {
      return;
    }

    if (input.selectionStart === 0 && input.selectionEnd === value.length) {
      const newValue = key; 
      if (!regex.test(newValue)) {
        e.preventDefault();
      }
    } else {
      const newValue = value + key;
      if (!regex.test(newValue)) {
        e.preventDefault();
      }
    }
  };

  const allowNumbersOnly3 = (e) => {
    const input = e.target;
    const value = input.value;
    const key = e.key;

    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    if (allowedKeys.includes(key)) {
      return;
    }

    const regex = /^\d{0,9}$/;

    const { selectionStart, selectionEnd } = input;

    const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);

    if (!regex.test(newValue)) {
      e.preventDefault();
    }
  };

  const handleCheckforward = (e) => {
    setIsbuttonChecked(e.target.checked);
  };

  const Subdata = (detail) => {
    if (roleid === "2" || roleid === "5" || roleid === "8") {
      setMandalid(detail.mandal_code);

      let params14 = {
        district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
        mandal_id: detail.mandal_code,
      };
      SwaranandhraService.getCpoForward(params14).then((res14) => {
        if (res14.data) {
          const item = res14.data[0]; formik.setFieldValue("forward", `${item.id},${item.roleid}`, false); formik.setFieldValue("forward_to", item.id, false); formik.setFieldValue("role_id", item.roleid, false);
          let options = res14.data.map((item, i) => { return ( <option key={`${item.id}-${item.roleid}`} value={`${item.id},${item.roleid}`}> {item.value} </option> ); });
          setForwardList(options);
        }
      });
    } else if (roleid === "10") {
      setMandalid(detail.mandal_code);

      let params15 = {
        district_id: district,
        mandal_id: detail.mandal_code,
      };
      SwaranandhraService.getAdForward(params15).then((res15) => {
        if (res15.data) {
          setAdforward(res15.data);
          let options = res15.data.map((item, i) => { return ( <option  key={`${item.id}-${item.roleid}`} value={`${item.id},${item.roleid}`}> {item.value} </option> ); });
          setForwardList(options);
        }
      });
    }
    setActiveTab("target");
    let params16 = { userId: username, district_id: detail.district_id, mandal_id: detail.mandal_code, };
    store.dispatch({ type: "SHOW_SPINNER" });
    MasterService.getSubIndicatorsForTarget(params16)
      .then((res16) => {
        if (res16.data && res16.data.SCODE === "01") {
          const mappedData = res16.data.SDESC.map((indicator) => {
            return {
              indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, is_reject: indicator.is_reject, expected_source_of_funding: indicator.expected_source_of_funding, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
            };
          });
          formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res16.data.buttonType); setWorkFlow(res16.data.workFlow); setRoleId(res16.data.SDESC[1].role_id); setForwardto(res16.data.SDESC[1].forward_to); setMandalName(res16.data.SDESC[1].mandal_name); setEnb(true); setEnbSub(false); setCurrentstatus(res16.data.current_status);
        }
      })
      .catch((err) => {
        ShowAlert(err, "error");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const handleCheckboxChange = (index) => {
    const newValues = [...formik.values.swaIndicatorsTargetDto];
    newValues[index].is_reject = !newValues[index].is_reject;
    formik.setFieldValue("swaIndicatorsTargetDto", newValues);
  };

  const handleCheckboxChange1 = (index) => {
    const newValues = [...formik.values.gmdpContributionSubListDto];
    newValues[index].is_reject = !newValues[index].is_reject;
    formik.setFieldValue("gmdpContributionSubListDto", newValues);
  };

  const hasInvalidValues = (data) => {
    return data.some((sector) => {
      if (sector.gmdp === null || sector.gmdp === "") {
        return true;
      }

      if (sector.is_data_entry && (sector.contribution === null || sector.contribution === "")) {
        return true;
      }

      return false;
    });
  };

  const hasInvalidValues1 = (data) => {
    return data.some((indicator) => {
      if (indicator.sub_indicator_id == null || indicator.sub_indicator_id === "") {
        return false;
      }

      const years = ["2024_2025", "2025_2026", "2026_2027", "2027_2028", "2028_2029"];

      return indicator.achived == null || indicator.achived === "" || years.some((year) => indicator[`target_${year}`] === null || indicator[`target_${year}`] === "");
    });
  };

  const Approve = () => {
    ShowAlert("Do you want to Approve..!", "warning", true).then((result) => {
      if (result.isConfirmed) {
        let params = {
          userId: username,
          district_id: roleid === "5" ? formik.values.district_id : district,
          mandal_id: roleid === "3" ? mandal : mandalid,
          forward_to: forwardto,
          remarks: formik.values.remarks,
          role_id: roleId,
          approved: "yes",
        };

        store.dispatch({ type: "SHOW_SPINNER" });
        SwaranandhraService.gettargetsAndGmdpForward(params)
          .then((res) => {
            if (res.data && res.data.SCODE === "01") {
              ShowAlert(res.data.SDESC, "success");
              setAddModal(false);

              if (roleid === "3") {
                let params = { userId: username, district_id: formik.values.district_id, mandal_id: formik.values.mandal_id, };
                MasterService.getSubIndicatorsForTarget(params).then((res) => {
                  if (res.data && res.data.SCODE === "01") {
                    const mappedData = res.data.SDESC.map((indicator) => {
                      return {
                        indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                      };
                    });
                    formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res.data.buttontype); setWorkFlow(res.data.workFlow); setRoleId(res.data.SDESC[1].role_id); setForwardto(res.data.SDESC[1].forward_to); setCurrentstatus(res.data.current_status);
                  }
                });
              } else if (roleid === "2" || roleid === "10" || roleid === "5" || roleid === "8") {
                let params = {
                  userId: username,
                  district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
                };
                SwaranandhraService.saveEntryForTarget(params).then((res) => {
                  if (res.data && res.data.SCODE === "01") {
                    setSubmandal(res.data.SDESC); setEnbSub(true); setEnb(false);
                  }
                });
              }
            }
          })
          .catch((err) => {
            ShowAlert(err, "error");
          })
          .finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
          });
      }
    });
  };

  const ForwardData = (e) => {
    formik.setFieldValue("forward", e.target.value);
    const selectedValue = e.target.value;
    const [id, roleid] = selectedValue.split(",");
    formik.setFieldValue("forward_to", id);
    formik.setFieldValue("role_id", roleid);
  };

  const handleClose = () => {
    setAddModal(false);
    formik.setFieldValue("remarks", "");
  };

  const handleClose1 = () => {
    setAddModal1(false);
    formik.setFieldValue("remarks", "");
  };

  const handleCheckAllChange = (isChecked) => {
    const newValues = formik.values.swaIndicatorsTargetDto.map((item) => ({
      ...item,
      is_reject: isChecked,
    }));
    formik.setFieldValue("swaIndicatorsTargetDto", newValues);
  };

  const handleCheckAllChange1 = (isChecked) => {
    const newValues = formik.values.gmdpContributionSubListDto.map((item) => ({
      ...item,
      is_reject: isChecked,
    }));
    formik.setFieldValue("gmdpContributionSubListDto", newValues);
  };

  const filteredData =
    searchText.length > 0
      ? submandal?.filter((item) => {
          return (
            item &&
            Object.keys(item).some((key) => {
              const value = item[key];
              return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase());
            })
          );
        })
      : submandal;

  useEffect(() => {
    let gmdpSum = 0;

    formik.values.gmdpContributionSubListDto.forEach((item, index) => {
      const gmdp = parseFloat(item.gmdp) || 0; 

      if (item.sector_id !== null) {
        gmdpSum += gmdp;
      } else {
        if (item.is_data_entry) {
          const roundedGmdpSum = parseFloat(gmdpSum.toFixed(2));

          formik.setFieldValue(`gmdpContributionSubListDto[${index}].gmdp`, roundedGmdpSum);
        }

        gmdpSum = 0;
      }
    });
  }, [formik.values.gmdpContributionSubListDto, formik.setFieldValue]);

  const calculateSum = (data, industryIds) => {
    return data.filter((item) => industryIds.includes(item.industry_id)).reduce((sum, item) => sum + parseFloat(item.gmdp) || 0, 0);
  };

  const calculateContribution = (sector, gmdpForIndustry22) => {
    const gmdpValue = parseFloat(sector.gmdp) || 0;
    const contribution = gmdpForIndustry22 === 0 ? 0 : (gmdpValue / gmdpForIndustry22) * 100;
    return contribution.toFixed(2);
  };

  const calculateGmdpForIndustry28 = (data) => {
    const gmdpFor26 = calculateSum(data, [26]);
    const gmdpFor27 = calculateSum(data, [27]);
    return safeDivide(gmdpFor26, gmdpFor27);
  };

  const calculateGmdpForIndustry25 = (data) => {
    const gmdpFor22 = calculateSum(data, [22]);
    const gmdpFor23 = calculateSum(data, [23]);
    const gmdpFor24 = calculateSum(data, [24]);
    return gmdpFor22 + gmdpFor23 - gmdpFor24;
  };

  const safeDivide = (numerator, denominator) => {
    if (denominator === 0) {
      return 0;
    }
    return Math.round((numerator / denominator) * 100000);
  };

  useEffect(() => {
    const gmdpForIndustry22 = calculateSum(formik.values.gmdpContributionSubListDto, [22]);
    formik.values.gmdpContributionSubListDto.forEach((sector, index) => {
      if (sector.industry_id === 22) {
        const sumForIndustry22 = calculateSum(formik.values.gmdpContributionSubListDto, [11, 6, 21]);
        formik.setFieldValue(`gmdpContributionSubListDto[${index}].gmdp`, parseFloat(sumForIndustry22).toFixed(2));
      }

      if (sector.industry_id === 25) {
        const gmdpForIndustry25 = calculateGmdpForIndustry25(formik.values.gmdpContributionSubListDto);
        formik.setFieldValue(`gmdpContributionSubListDto[${index}].gmdp`, parseFloat(gmdpForIndustry25).toFixed(2));
      }

      if (sector.industry_id === 28) {
        const gmdpForIndustry28 = calculateGmdpForIndustry28(formik.values.gmdpContributionSubListDto);
        formik.setFieldValue(`gmdpContributionSubListDto[${index}].gmdp`, gmdpForIndustry28);
      }
      if (sector.is_data_entry) {
        const contribution = calculateContribution(sector, gmdpForIndustry22);
        formik.setFieldValue(`gmdpContributionSubListDto[${index}].contribution`, contribution);
      }
    });
  }, [formik.values.gmdpContributionSubListDto, formik.setFieldValue]);

  const Next = () => {
    setActiveTab("gdmp");

    if (roleid === "3") {
      const hasInvalidValues1 = (data) => {
        return data.some((indicator) => {
          if (indicator.sub_indicator_id === null || indicator.sub_indicator_id === "") {
            return false;
          }

          const years = ["2024_2025", "2025_2026", "2026_2027", "2027_2028", "2028_2029"];

          return indicator.achived === null || indicator.achived === "" || years.some((year) => indicator[`target_${year}`] === null || indicator[`target_${year}`] === "");
        });
      };

      if (!hasInvalidValues1(formik.values.swaIndicatorsTargetDto)) {
        const transformFormikData = () => {
          return formik.values.swaIndicatorsTargetDto.map((indicator) => {
            const yearWiseTargets = [];
            const years = ["2024_2025", "2025_2026", "2026_2027", "2027_2028", "2028_2029"];

            years.forEach((year, index) => {
              const targetValue = indicator[`target_${year}`];
              yearWiseTargets.push({
                target: targetValue !== null && targetValue !== undefined && targetValue !== "" ? parseFloat(targetValue) : 0,
                f_year: 2024 + index,
              });
            });

            return {
              indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id,
              achived: indicator.achived !== null && indicator.achived !== undefined && indicator.achived !== "" ? parseFloat(indicator.achived) : 0,
              expected_source_of_funding: indicator.expected_source_of_funding, swaIndicatorsTargetYearWiseDto: yearWiseTargets, is_reject: indicator.is_reject,
            };
          });
        };

        const transformedData = transformFormikData();

        let params2 = { userId: username, type: buttontype, district_id: district, mandal_id: roleid === "3" ? mandal : mandalid, forward_to: forwardto, role_id: roleId, swaIndicatorsTargetDto: transformedData, };
        SwaranandhraService.saveEntryForTarget(params2).then((res) => {
          if (res.data && res.data.SCODE === "01") {
            if (roleid === "3") {
              let params = {
                userId: username,
                district_id: formik.values.district_id,
                mandal_id: formik.values.mandal_id,
              };
              MasterService.getSubIndicatorsForTarget(params).then((res) => {
                if (res.data && res.data.SCODE === "01") {
                  const mappedData = res.data.SDESC.map((indicator) => {
                    return {
                      indicator_id: indicator.indicator_id, sub_indicator_id: indicator.sub_indicator_id, achived: indicator.achived, indicator_name: indicator.indicator_name, sub_indicator_name: indicator.sub_indicator_name, sno_2024_2025: indicator.sno_2024_2025, sno_2025_2026: indicator.sno_2025_2026, sno_2026_2027: indicator.sno_2026_2027, sno_2027_2028: indicator.sno_2027_2028, sno_2028_2029: indicator.sno_2028_2029, target_2024_2025: indicator.target_2024_2025, target_2025_2026: indicator.target_2025_2026, target_2026_2027: indicator.target_2026_2027, target_2027_2028: indicator.target_2027_2028, target_2028_2029: indicator.target_2028_2029, unit: indicator.unit, expected_source_of_funding: indicator.expected_source_of_funding, is_reject: indicator.is_reject, source_of_funding: indicator.source_of_funding, inserted_by: indicator.inserted_by, maxLength: indicator.max_length,
                    };
                  });
                  formik.setFieldValue("swaIndicatorsTargetDto", mappedData); setButtontype(res.data.buttontype); setWorkFlow(res.data.workFlow); setRoleId(res.data.SDESC[1].role_id); setForwardto(res.data.SDESC[1].forward_to); setCurrentstatus(res.data.current_status);
                }
              });
            }
          }
        });
      }

      let params = {
        userId: username,
        district_id: district,
        mandal_id: mandal,
      };
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.gmdpContributions(params)
        .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            const mappedData = res.data.SDESC.map((indicator) => {
              return {
                sector_id: indicator.sector_id, industry_id: indicator.industry_id, sector_name: indicator.sector_name, industry_name: indicator.industry_name, is_data_entry: indicator.is_data_entry, contribution: indicator.contribution, gmdp: indicator.gmdp, is_reject: indicator.is_reject,
              };
            });

            formik.setFieldValue("gmdpContributionSubListDto", mappedData); setButtontypegdmp(res.data.buttonType); setWorkFlow(res.data.workFlow); setRoleId(res.data.SDESC[1].role_id); setForwardto(res.data.SDESC[1].forward_to); setCurrentstatus(res.data.current_status);
          }
          setEnb(true);
        })
        .catch((err) => {
          ShowAlert(err, "error");
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });

      let params1 = {
        district_id: district,
      };

      SwaranandhraService.getAsoForward(params1)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            const item = res.data[0]; formik.setFieldValue("forward", `${item.id},${item.roleid}`, false); formik.setFieldValue("forward_to", item.id, false); formik.setFieldValue("role_id", item.roleid, false);
            const options = ( <option key={item.id} value={`${item.id},${item.roleid}`}> {item.value} </option> );
            setForwardList([options]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      setEnb(true);
    }

    if (roleid !== "3") {
      if (roleid === "2" || roleid === "5" || roleid === "8") {
        let params = {
          district_id: roleid === "5" || roleid === "8" ? formik.values.district_id : district,
          mandal_id: mandalid,
        };
        SwaranandhraService.getCpoForward(params).then((res) => {
          if (res.data) {
            const item = res.data[0];
            formik.setFieldValue("forward", `${item.id},${item.roleid}`, false);
            formik.setFieldValue("forward_to", item.id, false);
            formik.setFieldValue("role_id", item.roleid, false);
            let options = res.data.map((item, i) => {
              return (
                <option key={i} value={`${item.id},${item.roleid}`}>
                  {item.value}
                </option>
              );
            });
            setForwardList(options);
          }
        });
      } else if (roleid === "10") {
        let params = {
          district_id: district,
          mandal_id: mandalid,
        };
        SwaranandhraService.getAdForward(params).then((res) => {
          if (res.data) {
            setAdforward(res.data);
            let options = res.data.map((item, i) => { return ( <option key={i} value={`${item.id},${item.roleid}`}> {item.value} </option> ); });
            setForwardList(options);
          }
        });
      }
      let params = {
        userId: username,
        district_id: formik.values.district_id,
        mandal_id: mandalid,
      };
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.gmdpContributions(params)
        .then((res) => {
          if (res.data && res.data.SCODE === "01") {
            const mappedData = res.data.SDESC.map((indicator) => {
              return {
                sector_id: indicator.sector_id, industry_id: indicator.industry_id, sector_name: indicator.sector_name, industry_name: indicator.industry_name, is_data_entry: indicator.is_data_entry, contribution: indicator.contribution, gmdp: indicator.gmdp, is_reject: indicator.is_reject,
              };
            });
formik.setFieldValue("gmdpContributionSubListDto", mappedData); setButtontypegdmp(res.data.buttonType); setWorkFlow(res.data.workFlow); setRoleId(res.data.SDESC[1].role_id); setForwardto(res.data.SDESC[1].forward_to); setCurrentstatus(res.data.current_status); setMandalName(res.data.SDESC[1].mandal_name);
          }

          setEnb(true);
          setEnbSub(false);
        })
        .catch((err) => {
          ShowAlert(err, "error");
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }
  };

  const Previous = () => {
    setActiveTab("target");
  };

  const SaveDatagdmp = () => {
    const transformFormikData = () => {
      return formik.values.gmdpContributionSubListDto.map((sector) => {
        return {
          sector_id: sector.sector_id,
          industry_id: sector.industry_id,
          gmdp: sector.gmdp !== null && sector.gmdp !== undefined && sector.gmdp !== "" ? parseFloat(sector.gmdp) : 0,
          contribution: sector.contribution !== null && sector.contribution !== undefined && sector.contribution !== "" ? parseFloat(sector.contribution) : 0,
          is_reject: sector.is_reject,
        };
      });
    };
    const transformedData = transformFormikData();
    let params = {
      userId: username,
      button_type: buttontypegdmp,
      district_id: district,
      mandal_id: roleid === "3" ? mandal : mandalid,
      forward_to: forwardto,
      role_id: roleId,
      gmdpContributionSubListDto: transformedData,
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.gmdpContributions(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") {
          ShowAlert(res.data.SDESC, "success");

          let params = {
            userId: username,
            district_id: formik.values.district_id,
            mandal_id: formik.values.mandal_id,
          };
          SwaranandhraService.gmdpContributions(params).then((res) => {
            if (res.data && res.data.SCODE === "01") {
              const mappedData = res.data.SDESC.map((indicator) => {
                return {
                  sector_id: indicator.sector_id,
                  industry_id: indicator.industry_id,
                  sector_name: indicator.sector_name,
                  industry_name: indicator.industry_name,
                  is_data_entry: indicator.is_data_entry,
                  contribution: indicator.contribution,
                  gmdp: indicator.gmdp,
                  is_reject: indicator.is_reject,
                };
              });

              formik.setFieldValue("gmdpContributionSubListDto", mappedData);
              setButtontypegdmp(res.data.buttonType);
              setWorkFlow(res.data.workFlow);
              setRoleId(res.data.SDESC[1].role_id);
              setForwardto(res.data.SDESC[1].forward_to);
              setCurrentstatus(res.data.current_status);
            }
            setEnb(true);
          });
        }
      })
      .catch((err) => {
        ShowAlert(err, "error");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  return (
    <>
      <Menubar />

      <Container fluid className="map-header mx-2">
        <div className="sa-title">
          {roleid === "3" && activeTab === "target" && (
            <h2>
              Targets & Achievements <span>Entry</span>
            </h2>
          )}
          {roleid === "3" && activeTab === "gdmp" && (
            <h2>
              Gross Mandal Domestic Product <span> Entry</span>
            </h2>
          )}
          {roleid !== "3" && activeTab === "target" && !enbSub && (
            <h2>
              Targets & Achievements<span> Details</span>
            </h2>
          )}
          {roleid !== "3" && activeTab === "gdmp" && (
            <h2>
              Gross Mandal Domestic Product<span> Details</span>
            </h2>
          )}
        </div>
      </Container>

      <Container fluid className="mt-5">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <h5>District</h5>
                  <Field className="mb-3 form-control" component="select" name="district_id" controlId="formBasicEmail" disabled={distEnb} style={{ fontWeight: "bold" }}>
                    <option value="">--Select--</option> {distlist}
                  </Field>
                </Col>
                {roleid === "3" ? (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                    <h5>Mandal</h5>
                    <Field className="mb-3 form-control" component="select" name="mandal_id" controlId="formBasicEmail" disabled={manEnb} style={{ fontWeight: "bold" }}>
                      <option value="">--Select--</option> {mandallist}
                    </Field>
                  </Col>
                ) : null}
                {roleid === "5" || roleid === "8" ? (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                    <button type="submit" className="btn btn-success mt-4">
                      VIEW DATA
                    </button>
                  </Col>
                ) : null}
              </Row>
            </div>
          </Form>
        </FormikProvider>
      </Container>

      <Container fluid className="px-4 py-5">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Tab.Container id="left-tabs-example" activeKey={activeTab}>
              {enb ? (
                <div className="tabs-top">
                  <Nav variant="pills" className="flex-column">
                    <Row className="tabs-row">
                      <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0">
                        <Nav.Item className="tab-boxes tab-boxes1">
                          <Nav.Link
                            eventKey="target"
                            onClick={() => Previous()}
                            active={activeTab === "target"}
                            style={{
                              fontWeight: activeTab === "target" ? "bold" : "normal",
                              borderBottom: activeTab === "target" ? "" : "2px solid transparent",
                            }}
                          >
                            <p>
                              Targets & Achievements
                              <br />
                              Entry
                            </p>
                          </Nav.Link>
                        </Nav.Item>
                      </Col>

                      <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0">
                        <Nav.Item className="tab-boxes tab-boxes2">
                          <Nav.Link
                            eventKey="gdmp"
                            onClick={() => {
                              if (buttontype === "save") {
                                alert("Please save the target entry data first.");
                              } else {
                                Next();
                              }
                            }}
                            disabled={buttontype === "save" || formik.values.swaIndicatorsTargetDto.length === 0}
                            active={activeTab === "gdmp"}
                            style={{
                              fontWeight: activeTab === "gdmp" ? "bold" : "normal",
                              borderBottom: activeTab === "gdmp" ? "" : "2px solid transparent",
                              cursor: buttontype === "save" ? "not-allowed" : "pointer",
                            }}
                          >
                            <p>Gross Mandal Domestic Product Entry</p>
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"></Col>
                      <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4"></Col>
                      {roleid !== "3" && (
                        <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="mx-4 px-4">
                          <Button
                            variant="warning"
                            size="sm"
                            className="btn mx-4 mt-4 warn-btn"
                            onClick={() => {
                              setEnb(false);
                              setEnbSub(true);
                            }}
                          >
                            <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </Nav>
                </div>
              ) : null}

              {roleid !== "3" && enbSub && 
                
                  <Row className="justify-content-center">
                    <Col xs={6} sm={12} lg={9} md={9} xl={9} xxl={9}>
                      <div className="input-group mt-2">
                        <div className="input-group-prepend">
                          <div class="input-group-text group_txt11" id="btnGroupAddon">
                            <AiOutlineSearch />
                          </div>
                        </div>
                        <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearchText(event.target.value)} />
                      </div>

                      <table className="table table-bordered custom-table table-responsive mt-5">
                        <thead>
                          <tr className="text-center">
                            <th>Sl.No.</th>
                            <th>Mandal</th>
                            <th>
                              Initiated Indicators
                              <br /> List
                            </th>
                            <th>ASO Submission Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData?.length === 0 ? (
                            <tr>
                              <td className="text-center fw-bold" style={{ color: "red" }} colSpan={5}>
                                Details Not Found
                              </td>
                            </tr>
                          ) : (
                            filteredData?.map((detail, i) => (
                              <tr key={i}>
                                <td style={{ textAlign: "center" }}>{i + 1}</td>
                                <td className="text-left text-start">
                                  {detail.records_count > 0 ? (
                                    <Link
                                      style={{ cursor: "pointer", color: "red", textDecoration: "none", fontFamily: "sans-serif" }}
                                      onClick={() => {
                                        Subdata(detail);
                                      }}
                                    >
                                      {detail.mandal_name}
                                    </Link>
                                  ) : (
                                    detail.mandal_name
                                  )}
                                </td>
                                <td className="text-center">
                                  {detail.records_count > 0 ? (
                                    <Link
                                      style={{ cursor: "pointer", color: "red", textDecoration: "none", fontFamily: "sans-serif" }}
                                      onClick={() => {
                                        Subdata(detail);
                                      }}
                                    >
                                      {detail.records_count}
                                    </Link>
                                  ) : (
                                    detail.records_count
                                  )}
                                </td>
                                <td className="text-center">
                                  {detail.records_count > 0 ? (
                                    <Link
                                      style={{ cursor: "pointer", color: "red", textDecoration: "none", fontFamily: "sans-serif" }}
                                      onClick={() => {
                                        Subdata(detail);
                                      }}
                                    >
                                      {detail.t_a_submitted_date}
                                    </Link>
                                  ) : (
                                    detail.t_a_submitted_date
                                  )}
                                </td>
                                <td className="text-center">
                                  {detail.records_count > 0 ? (
                                    <Link
                                      style={{ cursor: "pointer", color: "red", textDecoration: "none", fontFamily: "sans-serif" }}
                                      onClick={() => {
                                        Subdata(detail);
                                      }}
                                    >
                                      {detail.status}
                                    </Link>
                                  ) : (
                                    detail.status
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                
              }

              <Row>
                <Col xxl={9} xl={9} lg={9} md={12} sm={12} xs={12} className="">
                  <Tab.Content className="tabs-body-text">
                    {enb && (
                      <Tab.Pane eventKey="target">
                        <Button variant="danger" size="sm" className="btn mx-2 mt-2 mb-1 pdf-btn" onClick={generatePdf} style={{ float: "right", marginLeft: "3px" }}>
                          PDF
                          <MdOutlinePictureAsPdf />
                        </Button>
                        <Button variant="success" size="sm" className="btn mx-2 mt-2 mb-1 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Targets & Achievements Report")}>
                          <span style={{ color: "green" }}>
                            Excel
                            <AiFillFileExcel style={{ fontSize: "18px" }} />
                          </span>
                        </Button>
                        <table className="table table-bordered custom-table table-responsive mt-5" id="my-table">
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                            {roleid !== "3" && (
                              <tr>
                                <th className="text-center" colSpan={roleid === "3" ? 11 : 12}>
                                  MANDAL: {mandalName}
                                </th>
                              </tr>
                            )}
                            <tr className="text-center">
                              <th rowSpan={2}>Sl.No.</th>
                              <th rowSpan={2}>INDICATOR</th>
                              <th rowSpan={2}>UNIT</th>
                              <th colSpan={1}>ACHIEVEMENTS</th>
                              <th colSpan={5}>TARGETS</th>
                              <th rowSpan={2} style={{ borderRadius: "0px 10px 0px 0px" }}>
                                Indicative Financial <br />
                                Plan-Expected sources <br /> of funding
                              </th>
                              {roleid !== "3" ? (
                                <th rowSpan={2}>
                                  Check All
                                  <Field
                                    type="checkbox"
                                    className="mx-2 mt-1"
                                    name="checkAll"
                                    checked={formik.values.swaIndicatorsTargetDto.every((item) => item.is_reject)}
                                    onChange={(e) => handleCheckAllChange(e.target.checked)}
                                    style={{ transform: "scale(1.8)" }}

                                    // disabled={roleId !== "3" && roleId !== "10" && roleId !== "100" && (roleid === "5" || roleid === "8") ? false : roleId === roleid ? false : true}
                                  disabled={ !( (!["3", "10", "100"].includes(roleId) && ["5", "8"].includes(roleid)) || roleId === roleid ) }
                                  />
                                </th>
                              ) : null}
                            </tr>
                            <tr>
                              <th>2023-24</th>
                              <th>2024-25</th>
                              <th>2025-26</th>
                              <th>2026-27</th>
                              <th>2027-28</th>
                              <th>2028-29</th>
                            </tr>
                          </thead>

                          <FieldArray name="swaIndicatorsTargetDto">
                            {({ push, remove, form }) => {
                              const renderedIndicators = new Set();
                              let serialNumber = 0;
                              if (form.values.swaIndicatorsTargetDto.length === 0) {
                                return (
                                  <tbody>
                                    <tr>
                                      <td colSpan={10} className="text-center" style={{ color: "red" }}>
                                        No details found
                                      </td>
                                    </tr>
                                  </tbody>
                                );
                              }

                              return (
                                <tbody>
                                  {form.values.swaIndicatorsTargetDto.map((indicator, index) => {
                                    const isFirstOccurrence = !renderedIndicators.has(indicator.indicator_name);
                                    if (isFirstOccurrence) {
                                      renderedIndicators.add(indicator.indicator_name);
                                    }

                                    const isRejected = form.values.swaIndicatorsTargetDto[index].is_reject;
                                    const insertby = form.values.swaIndicatorsTargetDto[index].inserted_by;

                                    const isDisabled = roleid === "3" ? (roleId === null || (roleId === roleid && isRejected) || insertby === "supt_planning" ? false : true) : true;

                                    if (!isFirstOccurrence) {
                                      serialNumber++;
                                    }
                                    return (
                                      <tr key={index}>
                                        {!isFirstOccurrence ? <td className="text-center">{!isFirstOccurrence ? serialNumber : ""}</td> : null}
                                        <td
                                          className={`text-left fw-semibold text-start ${isFirstOccurrence ? "highlighted-text" : ""}`}
                                          colSpan={isFirstOccurrence ? 11 : null}
                                        >
                                          {isFirstOccurrence ? indicator.indicator_name : indicator.sub_indicator_name}
                                        </td>

                                        {!isFirstOccurrence ? (
                                          <td className="text-center text-start" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {indicator.unit}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-right text-end " style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? indicator.achived : <Field autoComplete="off" className="form-control" name={`swaIndicatorsTargetDto[${index}].achived`} type="text" onKeyPress={(e) => allowNumbersOnly(e, indicator.maxLength)} style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-right text-end" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? indicator.target_2024_2025 : <Field autoComplete="off" className="form-control" name={`swaIndicatorsTargetDto[${index}].target_2024_2025`} type="text" onKeyPress={(e) => allowNumbersOnly(e, indicator.maxLength)} style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-right text-end" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? indicator.target_2025_2026 : <Field autoComplete="off" className="form-control" name={`swaIndicatorsTargetDto[${index}].target_2025_2026`} type="text" onKeyPress={(e) => allowNumbersOnly(e, indicator.maxLength)} style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-right text-end" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? indicator.target_2026_2027 : <Field className="form-control" name={`swaIndicatorsTargetDto[${index}].target_2026_2027`} type="text" onKeyPress={(e) => allowNumbersOnly(e, indicator.maxLength)} autoComplete="off" style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-right text-end" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? indicator.target_2027_2028 : <Field className="form-control" name={`swaIndicatorsTargetDto[${index}].target_2027_2028`} type="text" onKeyPress={(e) => allowNumbersOnly(e, indicator.maxLength)} autoComplete="off" style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-right text-end" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? indicator.target_2028_2029 : <Field className="form-control" name={`swaIndicatorsTargetDto[${index}].target_2028_2029`} type="text" onKeyPress={(e) => allowNumbersOnly(e, indicator.maxLength)} autoComplete="off" style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>
                                        ) : null}

                                        {!isFirstOccurrence ? (
                                          <td className="text-center" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            {isDisabled ? (
                                              indicator.source_of_funding
                                            ) : (
                                              <Field name={`swaIndicatorsTargetDto[${index}].expected_source_of_funding`} className="form-control" component="select" disabled={isDisabled}>
                                                <option value="">--Select--</option> {sourcelist}
                                              </Field>
                                            )}
                                          </td>
                                        ) : null}

                                        {roleid !== "3" && !isFirstOccurrence ? (
                                          <td className="text-center" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                            <Field
                                              type="checkbox"
                                              name={`swaIndicatorsTargetDto[${index}].is_reject`}
                                              checked={formik.values.swaIndicatorsTargetDto[index].is_reject}
                                              onChange={() => handleCheckboxChange(index)}
                                              // disabled={roleId !== "3" && roleId !== "10" && roleId !== "100" && (roleid === "5" || roleid === "8") ? false : roleId === roleid ? false : true}
                                              disabled={ !( (!["3", "10", "100"].includes(roleId) && ["5", "8"].includes(roleid)) || roleId === roleid ) }

                                              style={{ transform: "scale(1.4)" }}
                                            />
                                          </td>
                                        ) : null}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              );
                            }}
                          </FieldArray>
                        </table>

                        {formik.values.swaIndicatorsTargetDto.length > 0 && ((roleId !== "3" && roleId !== "10" && roleId !== "100" && (roleid === "5" || roleid === "8")) || roleId === roleid || roleId === null) ? 
                          
                            <div className="bottom-buttons d-flex justify-content-end mt-4">
                              {roleid === "3" && (
                                <Button variant="" size="sm" className="save-btn me-4" onClick={SaveData}>
                                  {buttontype} <FaRegSave className="ms-1 s-icon" />
                                </Button>
                              )}

                              <Button
                                variant=""
                                size="sm"
                                className="next-btn"
                                onClick={() => {
                                  if (buttontype === "save") {
                                    alert("Please save the target entry data first.");
                                  } else {
                                    Next();
                                  }
                                }}
                                disabled={buttontype === "save"}
                              >
                                Next <FaArrowRightLong className="ms-1 n-icon" />
                              </Button>
                            </div>
                          
                         : null}
                      </Tab.Pane>
                    )}

                    {enb && (
                      <Tab.Pane eventKey="gdmp">
                        <Button variant="danger" size="sm" className="btn mx-2 mt-2 mb-1 pdf-btn" onClick={generatePdf1} style={{ float: "right", marginLeft: "3px" }}>
                          PDF
                          <MdOutlinePictureAsPdf />
                        </Button>
                        <Button variant="success" size="sm" className="btn mx-2 mt-2 mb-1 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table1", "Gross Mandal Domestic Entry Report")}>
                          <span style={{ color: "green" }}>
                            Excel <AiFillFileExcel style={{ fontSize: "18px" }} />
                          </span>
                        </Button>
                        <table className="table table-bordered custom-table table-responsive mt-5" id="my-table1">
                          <thead>
                            {roleid !== "3" && (
                              <tr>
                                <th className="text-center" colSpan={roleid === "3" ? 11 : 12}>
                                  MANDAL: {mandalName}
                                </th>
                              </tr>
                            )}
                            <tr className="text-center">
                              <th rowSpan={2}>Sl.No.</th>
                              <th rowSpan={2}>BROAD SECTOR</th>
                              <th rowSpan={2}>SUB SECTOR</th>
                              <th colSpan={2}>2022-23</th>
                              {roleid !== "3" ? (
                                <th rowSpan={2}>
                                  Check All <br />
                                  <Field
                                    type="checkbox"
                                    className="mx-2 mt-1"
                                    name="checkAll"
                                    checked={formik.values.gmdpContributionSubListDto.every((item) => item.is_reject)}
                                    onChange={(e) => handleCheckAllChange1(e.target.checked)}
                                    style={{ transform: "scale(1.8)" }}
                                    // disabled={roleId !== "3" && roleId !== "10" && roleId !== "100" && (roleid === "5" || roleid === "8") ? false : roleId === roleid ? false : true}
                                     disabled={ !( (!["3", "10", "100"].includes(roleId) && ["5", "8"].includes(roleid)) || roleId === roleid ) }

                                 />
                                </th>
                              ) : null}
                            </tr>
                            <tr>
                              <th>
                                GVA <br />
                                (Rs. in Lakhs)
                              </th>
                              <th>
                                Contribution <br />
                                (%)
                              </th>
                            </tr>
                          </thead>

                          <FieldArray name="gmdpContributionSubListDto">
                            {({ form }) => {
                              const seenSectors = new Set();

                              return (
                                <tbody>
                                  {form.values.gmdpContributionSubListDto.length === 0 ? (
                                    <tr>
                                      <td colSpan={6} className="text-center" style={{ color: "red" }}>
                                        No details found
                                      </td>
                                    </tr>
                                  ) : (
                                    form.values.gmdpContributionSubListDto.map((sector, index) => {
                                      const isRejected = sector.is_reject;
                                      const isDisabled = roleid === "3" ? (roleId === null || (roleId === roleid && isRejected) ? false : true) : true;

                                      const isFirstOccurrence = sector.sector_name && !seenSectors.has(sector.sector_name);
                                      if (sector.sector_name) {
                                        seenSectors.add(sector.sector_name);
                                      }

                                      return (
                                        <tr key={index}>
                                          <td className="text-center">{index + 1}</td>

                                          <td className="text-left fw-semibold" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit", fontSize: "17px" }}>
                                            {isFirstOccurrence ? sector.sector_name : ""}
                                          </td>

                                          <td
                                            className={isRejected ? "rgb(255 219 154)" : sector.sector_id == null && sector.is_data_entry ? "td-background-color" : "inherit"}
                                            style={{
                                              backgroundColor: isRejected ? "rgb(255 219 154)" : (sector.sector_id === null && sector.is_data_entry) || sector.industry_id === 22 || sector.industry_id === 25 || sector.industry_id === 28 ? "#cbc4c4" : "inherit",
                                              fontWeight: (sector.sector_id === null && sector.is_data_entry) || sector.industry_id === 22 || sector.industry_id === 25 || sector.industry_id === 28 ? "bold" : "normal",
                                              fontSize: "16px",
                                              textAlign: "left",
                                            }}
                                          >
                                            {sector.industry_name}
                                          </td>

                                          <td
                                            style={{
                                              backgroundColor: isRejected ? "rgb(255 219 154)" : (sector.sector_id === null && sector.is_data_entry) || sector.industry_id === 22 || sector.industry_id === 25 || sector.industry_id === 28 ? "#cbc4c4" : "inherit",
                                              textAlign: "right",
                                            }}
                                            className="text-right"
                                          >
                                            {isDisabled ? sector.gmdp : <Field className="form-control" name={`gmdpContributionSubListDto[${index}].gmdp`} type="text" onKeyPress={(e) => (sector.industry_id === 27 ? allowNumbersOnly3(e) : allowNumbersOnly(e))} disabled={isDisabled} style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                          </td>

                                          {sector.is_data_entry ? (
                                            <td
                                              className="text-right"
                                              style={{
                                                backgroundColor: isRejected ? "rgb(255 219 154)" : sector.sector_id == null && sector.is_data_entry ? "#cbc4c4" : "inherit",
                                                textAlign: "right",
                                              }}
                                            >
                                              {isDisabled ? <span>{sector.contribution}</span> : <Field className="form-control" name={`gmdpContributionSubListDto[${index}].contribution`} type="text" onKeyPress={(e) => allowNumbersOnly1(e)} disabled={isDisabled} style={{ textAlign: "right" }} onFocus={(e) => (e.target.value = "")} />}
                                            </td>
                                          ) : (
                                            <td
                                              style={{
                                                backgroundColor: isRejected ? "rgb(255 219 154)" : (sector.sector_id === null && sector.is_data_entry) || sector.industry_id === 22 ? "#cbc4c4" : "inherit",
                                                textAlign: "right",
                                              }}
                                            >
                                              {sector.industry_id === 22 && formik.values.gmdpContributionSubListDto[index].gmdp > 0 ? 100 : null}
                                            </td>
                                          )}

                                          {roleid !== "3" && sector.industry_id !== 22 && sector.industry_id !== 25 && sector.industry_id !== 28 && sector.industry_id !== 11 && sector.industry_id !== 6 && sector.industry_id !== 21 && (
                                            <td className="text-center" style={{ backgroundColor: isRejected ? "rgb(255 219 154)" : "inherit" }}>
                                              <Field
                                                type="checkbox"
                                                name={`gmdpContributionSubListDto[${index}].is_reject`}
                                                checked={form.values.gmdpContributionSubListDto[index].is_reject}
                                                onChange={() => handleCheckboxChange1(index)}
                                                // disabled={roleId !== "3" && roleId !== "10" && roleId !== "100" && (roleid === "5" || roleid === "8") ? false : roleId === roleid ? false : true}
                                                disabled={ !( (!["3", "10", "100"].includes(roleId) && ["5", "8"].includes(roleid)) || roleId === roleid ) }

                                                style={{ transform: "scale(1.4)" }}
                                              />
                                            </td>
                                          )}
                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>
                              );
                            }}
                          </FieldArray>
                        </table>

                        {formik.values.gmdpContributionSubListDto.length > 0 && ((roleId !== "3" && roleId !== "10" && roleId !== "100" && (roleid === "5" || roleid === "8")) || roleId === roleid || roleId === null) ? (
                          <>
                            {roleid === "3" && (
                              <div className="warning-box d-flex mt-4">
                                <Field type="checkbox" name="checked" id="custom-checkbox" onChange={handleCheckforward} checked={isbuttonChecked} className="me-4 check-box-width" style={{ transform: "scale(1.8)" }} />
                                <p>You are about to submit the data for scrutiny. As an authorized officer, your submission will be considered final, and no further changes can be made after this step. Please carefully review all the data to ensure its accuracy before proceeding, as this action will move the data forward for scrutiny without the possibility of further edits.</p>
                                <img src="images/warning.webp" alt="warning" className="img-fluid" />
                              </div>
                            )}

                            <div className="bottom-buttons d-flex justify-content-center align-items-start mt-4" style={{ gap: "0" }}>
                              <Button variant="warning" size="sm" className="btn mx-4 mt-4 save-btn" onClick={() => Previous()}>
                                <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} />
                                Previous
                              </Button>

                              {roleid === "3" ? (
                                <Button variant="" size="sm" className="btn  save-btn mt-4 mx-4" onClick={() => SaveDatagdmp()}>
                                  <IoIosSave style={{ fontSize: "18px", marginRight: "5px" }} />
                                  {buttontypegdmp}
                                </Button>
                              ) : (
                                <Button
                                  variant="danger"
                                  size="sm"
                                  className="btn mx-4 mt-4 return-btn"
                                  style={{ backgroundColor: "red" }}
                                  onClick={() => {
                                    if (hasAtLeastOneReject(formik.values.gmdpContributionSubListDto) || hasAtLeastOneReject(formik.values.swaIndicatorsTargetDto)) {
                                      setAddModal1(true);
                                      formik.setFieldValue("remarks", "");
                                    } else {
                                      ShowAlert("Select at least one indicator to return", "warning");
                                    }

                                    if (roleid === "10") {
                                      const item = adforward[1];
                                      formik.setFieldValue("forward", `${item.id},${item.roleid}`, false);
                                      formik.setFieldValue("forward_to", item.id, false);
                                      formik.setFieldValue("role_id", item.roleid, false);
                                    }
                                  }}
                                >
                                  <IoIosReturnLeft style={{ fontSize: "18px", marginRight: "5px" }} />
                                  Return
                                </Button>
                              )}

                              {roleid !== "2" && roleid !== "5" && roleid !== "8" && (isbuttonChecked || roleid !== "3") && (
                                <Button
                                  variant=""
                                  size="sm"
                                  className="btn mx-4 mt-4 next-btn"
                                  onClick={() => {
                                    const { gmdpContributionSubListDto } = formik.values;
                                    const invalidValues = hasInvalidValues(gmdpContributionSubListDto);
                                    const rejectIndicators = hasRejectIndicators(gmdpContributionSubListDto);
                                    const { swaIndicatorsTargetDto } = formik.values;
                                    const invalidValues1 = hasInvalidValues1(swaIndicatorsTargetDto);
                                    const rejectIndicators1 = hasRejectIndicators(swaIndicatorsTargetDto);

                                    if (roleid !== "3") {
                                      if (rejectIndicators || rejectIndicators1) {
                                        ShowAlert("Please uncheck all indicators to forward", "error");
                                      } else if (invalidValues || invalidValues1) {
                                        ShowAlert("Please fill all fields", "error");
                                      } else {
                                        setAddModal(true);
                                        formik.setFieldValue("remarks", "");
                                      }
                                    } else {
                                      if (invalidValues || invalidValues1) {
                                        ShowAlert("Please fill all fields", "error");
                                      } else {
                                        setAddModal(true);
                                        formik.setFieldValue("remarks", "");
                                      }
                                    }

                                    if (roleid === "10") {
                                      const item = adforward[0];
                                      formik.setFieldValue("forward", `${item.id},${item.roleid}`, false);
                                      formik.setFieldValue("forward_to", item.id, false);
                                      formik.setFieldValue("role_id", item.roleid, false);
                                    }
                                  }}
                                >
                                  Forward <IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} />
                                </Button>
                              )}

                              {(roleid === "2" || roleid === "5" || roleid === "8") && (
                                <Button
                                  variant=""
                                  size="sm"
                                  className="btn mt-4 next-btn"
                                  onClick={() => {
                                    const { gmdpContributionSubListDto } = formik.values;
                                    const { swaIndicatorsTargetDto } = formik.values;
                                    const rejectIndicators = hasRejectIndicators(gmdpContributionSubListDto);
                                    const rejectIndicators1 = hasRejectIndicators(swaIndicatorsTargetDto);
                                    if (rejectIndicators || rejectIndicators1) {
                                      ShowAlert("Please uncheck all indicators to forward", "error");
                                    } else {
                                      Approve();
                                    }
                                  }}
                                >
                                  <FaBookmark style={{ fontSize: "14px" }} />
                                  Approve
                                </Button>
                              )}
                            </div>
                          </>
                        ) : null}
                      </Tab.Pane>
                    )}
                  </Tab.Content>
                </Col>

                {enb && (
                  <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className="mt-5">
                    <div className="card-all">
                      <h2>Activity Track</h2>
                      {workFlow && workFlow.length === 0 ? (
                        <div className="card-info d-flex"> <div className="user-icon-box"> <div className="user-icon"> <RiUserFollowLine /> </div> </div> <div className="user-details"> <div className="user-details-text"> <h3>Current Status: ASO not yet submitted</h3> </div> </div> </div>
                      ) : (
                        workFlow?.map((item, index) => (
                          <div key={index} className="card-info d-flex"> <div className="user-icon-box"> <div className="user-icon"> <RiUserFollowLine /> </div> </div> <div className="user-details"> <div className="user-details-text"> <h3>{item.uname}</h3> <p>{item.submitted_date}</p> </div> <img src="images/message.webp" className="img-fluid" data-tip={item.remarks} alt="message" data-for={`tooltip-${index}`} /> 
                          {/* <Tooltip
 id={`tooltip-${index}`} place="top" effect="solid" className="custom-tooltipp"> */}
                             <PiNotePencilDuotone style={{ fontSize: "24px", color: "black" }} /> <strong style={{ fontSize: "18px" }}>Remarks: </strong> <br /> {item.remarks} 
                          {/* </Tooltip
> */} </div> </div>
                        ))
                      )}
                      {roleId !== null && workFlow.length !== 0 ? (
                        <p style={{ fontWeight: "bold", color: "#178a00" }} className="user-details1">
                          <h3>Current Status: {currentstatus}</h3>
                          <br />
                        </p>
                      ) : null}
                    </div>
                  </Col>
                )}
              </Row>
            </Tab.Container>
          </Form>
        </FormikProvider>
      </Container>

      <Modal fade={false} className="newmodal" aria-labelledby="contained-modal-title-vcenter" centered show={addModal}>
        <Modal.Header>
          <Modal.Title className="text-center">Confirm Forward</Modal.Title>
          <button
            type="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleClose();
              }
            }}
            className="close-button"
          >
            &#215;
          </button>
        </Modal.Header>
        <Modal.Body className="p-5">
          <Modal.Dialog className="internal">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    Forward To
                    <span>
                      <sup className="mandatort">*</sup>
                    </span>
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <p className="d-flex">
                    <FaUserCheck className="usericon" />
                    <Field component="select" name="forward" onChange={ForwardData} className="form-control" disabled={true}>
                      {forwardList}
                    </Field>
                  </p>
                </Modal.Body>

                <Modal.Footer>
                  Remarks <sup className="mandatort">*</sup>
                  <Field as="textarea" name="remarks" rows={2} cols={40} style={{ resize: "none" }} />
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Modal.Dialog>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="conform" onClick={SubmitData}>
            Confirm <FaRegFile />
          </button>
        </Modal.Footer>
      </Modal>

      <Modal fade={false} className="newmodal" aria-labelledby="contained-modal-title-vcenter" centered show={addModal1}>
        <Modal.Header>
          <Modal.Title className="text-center">Confirm</Modal.Title>
          <button
            type="button"
            tabIndex={0}
            onClick={handleClose1}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") handleClose1();
            }}
            className="close-icon"
          >
            &#215;
          </button>
        </Modal.Header>

        <Modal.Body className="p-5">
          <Modal.Dialog className="internal">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    RETURN TO
                    <span>
                      <sup className="mandatort">*</sup>
                    </span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p className="d-flex">
                    <FaUserCheck className="usericon" />
                    <Field component="select" name="forward" onChange={ForwardData} className="form-control " disabled={true}>
                      {forwardList}
                    </Field>
                  </p>
                </Modal.Body>

                <Modal.Footer>
                  Remarks <sup className="mandatort">*</sup>
                  <Field as="textarea" name="remarks" rows={2} cols={40} style={{ resize: "none" }} />
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Modal.Dialog>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="conform" onClick={Return}>
            Confirm <FaRegFile />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
